import moment from 'moment'

export class Utils {
  static snapshotToArr (snapshot) {
    if (!snapshot || !snapshot.docs) {
      return false
    }

    return snapshot.docs.map(doc => {
      let data = doc.data()
      data._id = doc.id
      return data
    })
  }

  static snapshotToObjMap (snapshot, filter) {
    if (!snapshot || !snapshot.docs) {
      return false
    }

    let obj = {}
    for (let doc of snapshot.docs) {
      let data = doc.data()
      data._id = doc.id
      if (this.filter(data, filter)) {
        obj[doc.id] = data
      }
    }
    return obj
  }

  static filterArr (arr, filters) {
    let filteredArr = []
    for (let item of arr) {
      if (this.applyFilters(item, filters)) {
        filteredArr.push(item)
      }
    }
    return filteredArr
  }

  static applyFilters (data, filters = []) {
    for (let filter of filters) {
      if (!this.filter(data, filter)) {
        return false
      }
    }
    return true
  }

  static filter (data, filter) {
    if (!filter || filter.value === null || filter.value === undefined) return true
    let dataValue = data[filter.key]
    switch (filter.operator) {
      case '==':
        return dataValue == filter.value // eslint-disable-line
      case '===':
        return dataValue === filter.value
      case '!=':
        return dataValue != filter.value // eslint-disable-line
      case '!===':
        return dataValue !== filter.value
      case '<':
        return dataValue < filter.value
      case '<=':
        return dataValue <= filter.value
      case '>':
        return dataValue > filter.value
      case '>=':
        return dataValue >= filter.value
      case 'startsWith':
        return `${dataValue}`.toLowerCase().indexOf(`${filter.value}`.toLowerCase()) === 0
      case 'contains':
        return `${dataValue}`.toLowerCase().indexOf(`${filter.value}`.toLowerCase()) >= 0
      case 'custom':
        return filter.filter(data, filter.value)
      default:
        return true
    }
  }

  static snapshotToObj (snapshot) {
    let data = false
    if (snapshot) {
      if (snapshot.docs && snapshot.docs.length) {
        data = snapshot.docs[0].data()
        data._id = snapshot.docs[0].id
      } else if (snapshot.exists) {
        data = snapshot.data()
        data._id = snapshot.id
      }
    }
    return data
  }

  static validate (rules, data) {
    let valid = true
    for (let k in rules) {
      let rule = rules[k]
      let value = data[k]
      if (typeof rule.validate === 'function') {
        let res = rule.validate(value, data)
        if (res !== true) {
          valid = false
          rule.msg = res
        } else {
          rule.msg = ''
        }
      } else if (rule.type === 'email') {
        let regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!regEx.test(String(value).toLowerCase())) {
          rule.msg = 'valid email address required'
          valid = false
        } else {
          rule.msg = ''
        }
      } else if (rule.type === 'date') {
        if (!moment(value, rule.format).isValid()) {
          rule.msg = 'date required'
          valid = false
        } else {
          rule.msg = ''
        }
      } else if (rule.type === 'chars') {
        if (`${value}`.length !== rule.length) {
          rule.msg = `${k} must have 4 characters`
          valid = false
        } else {
          rule.msg = ''
        }
      } else {
        if (value === undefined || value === null || !`${value}`.length) {
          rule.msg = '* required'
          valid = false
        } else {
          rule.msg = ''
        }
      }
    }
    return valid
  }

  static validateValue (rule, value) {
    let rules = { value: { type: rule } }
    let data = { value }
    return this.validate(rules, data)
  }
}
